"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderRow = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _FormattedMessage = require("./FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
/* 	following variables are shared between OrderRow components
 * 	React context usage is more preferable in this case
 */
let totalAmount = 0;
let totalBp = 0;
const shouldDeductFromTotal = true;
const Row = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  padding: '4px 0 5px',
  whiteSpace: 'nowrap',
  borderBottom: '1px solid #e5e5e5',
  borderBottomColor: theme.palette.grey[200],
  cursor: 'pointer',
  alignItems: 'center'
}));
const CheckboxNameWrapper = (0, _mui.styled)('div')({
  flexBasis: '70%',
  display: 'flex',
  alignItems: 'center'
});
const CheckboxContentWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'inline-block',
  width: theme.spacing(7)
}));
const CustomerName = (0, _mui.styled)('div')(({
  theme,
  ownerState
}) => ({
  display: 'inline-block',
  overflow: 'hidden',
  maxWidth: theme.spacing(32),
  lineHeight: '14px',
  fontSize: theme.typography.body1.fontSize,
  color: 'theme.palette.text.primary',
  textOverflow: 'ellipsis',
  fontWeight: ownerState.isChecked ? 'bold' : 'normal',
  [theme.breakpoints.up('md')]: {
    maxWidth: 203
  }
}));
const Bp = (0, _mui.styled)('div')(({
  theme,
  ownerState
}) => ({
  width: theme.spacing(16),
  fontWeight: ownerState.isChecked ? 'bold' : 'normal',
  textAlign: 'right',
  [theme.breakpoints.down(919)]: {
    display: 'none'
  }
}));
const CheckboxElement = (0, _mui.styled)(_mui.Checkbox)(({
  theme
}) => ({
  padding: 0
}));
const Amount = (0, _mui.styled)('div')(({
  theme,
  ownerState
}) => ({
  width: '30%',
  overflow: 'hidden',
  marginLeft: theme.spacing(1),
  fontSize: theme.typography.body1.fontSize,
  color: theme.palette.text.primary,
  textAlign: 'right',
  textOverflow: 'ellipsis',
  fontWeight: ownerState.isChecked ? 'bold' : 'normal'
}));
let selectedRows = [];
const calculateTotalAmount = (price, deduct = false) => {
  totalAmount = deduct ? totalAmount - price : totalAmount + price;
};
const calculateTotalBp = (bp, deduct = false) => {
  totalBp = deduct ? totalBp - bp : totalBp + bp;
};
const handleRowSelection = (id, priceValue, bp) => {
  if (selectedRows.includes(id)) {
    const index = selectedRows.indexOf(id);
    selectedRows.splice(index, 1);
    calculateTotalAmount(priceValue, shouldDeductFromTotal);
    calculateTotalBp(bp, shouldDeductFromTotal);
  } else {
    selectedRows.push(id);
    calculateTotalAmount(priceValue);
    calculateTotalBp(bp);
  }
};
const OrderRow = ({
  'data-testid': testId,
  name,
  price,
  priceValue,
  bp,
  rowId,
  setSelectedOrdersCount,
  setTotalAmountSelected,
  setTotalBp,
  setSelectedOrderIds,
  shouldReset
}) => {
  const [isChecked, setIsChecked] = (0, _react.useState)(false);
  const handleCheckboxChange = (0, _react.useCallback)(() => {
    setIsChecked(!isChecked);
    handleRowSelection(rowId, priceValue, Number.parseInt(bp, 10) || 0);
    setSelectedOrdersCount(selectedRows.length.toString());
    setTotalAmountSelected((Math.round((totalAmount + Number.EPSILON) * 100) / 100).toString());
    setTotalBp(totalBp.toString());
    setSelectedOrderIds(selectedRows);
  }, [isChecked, bp, priceValue, rowId, setSelectedOrdersCount, setTotalAmountSelected, setSelectedOrderIds, setTotalBp]);
  const ownerState = {
    isChecked
  };
  (0, _react.useEffect)(() => {
    setSelectedOrdersCount('0');
    setTotalAmountSelected('0');
    setTotalBp('0');
    setSelectedOrderIds([]);
    setIsChecked(false);
    totalAmount = 0;
    totalBp = 0;
    selectedRows = [];
  }, [setSelectedOrdersCount, setTotalAmountSelected, setTotalBp, setSelectedOrderIds, shouldReset, setIsChecked]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Row, {
    "data-order-id": rowId,
    "data-test-id": testId,
    onClick: handleCheckboxChange,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(CheckboxNameWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CheckboxContentWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(CheckboxElement, {
          "data-testid": `${testId}-checkbox`,
          checked: isChecked
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomerName, {
        ownerState: ownerState,
        children: name
      })]
    }), bp.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(Bp, {
      ownerState: ownerState,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "bpCount",
        values: {
          0: bp
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Amount, {
      ownerState: ownerState,
      children: price
    })]
  });
};
exports.OrderRow = OrderRow;